module.exports = __webpack_public_path__ + "static/media/WhatsNew-Post-It-Note.99edc694.png";